module.exports = __webpack_public_path__ + "img/tag-icon.70f4d84f.svg";